export class PersonalDataParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(PersonalData.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, PersonalData.build(item))
  }

  remove(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => PersonalData.build(el))
    }
    return this
  }
}

export class PersonalData {
  constructor() {
    this.id = null
    this.gender = null
  }

  getForAPI() {
    return {
      id: this.id,
      gender: this.gender
    }
  }

  static build(obj) {
    const _this = new PersonalData()
    if (obj) {
      _this.id = obj.id
      _this.gender = obj.gender
    }
    return _this
  }
}
